import store from "@/store";

export default {
  component: () => import("@/modules/admin/layouts/AdminLayout.vue"),
  children: [
    {
      path: "/semestres",
      name: "semestres",
      component: () => import("@/modules/admin/views/SemestresView.vue"),
      beforeEnter: (to, from, next) => {
        if (!sessionStorage.getItem('token')) next("/admin");
        else next();
      },
    },
    {
      path: "/periodos",
      name: "periodos",
      component: () => import("@/modules/admin/views/PeriodosView.vue"),
      beforeEnter: (to, from, next) => {
        if (!sessionStorage.getItem('token')) next("/admin");
        else next();
      },
    },
    {
      path: "/registros",
      name: "registros",
      component: () => import("@/modules/admin/views/RegistrosView.vue"),
      beforeEnter: (to, from, next) => {
        if (!sessionStorage.getItem('token')) next("/admin");
        else next();
      },
    },
    {
      path: "/reportes",
      name: "reportes",
      component: () => import("@/modules/admin/views/ReportesView.vue"),
      beforeEnter: (to, from, next) => {
        if (!sessionStorage.getItem('token')) next("/admin");
        else next();
      },
    },
  ],
};
